
import { Component, Input } from '@angular/core';

@Component({
  selector: 'perfil-user-component-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent {
@Input()title='';
@Input()subtitle='';
}
